import React from 'react';
import { TimerSettings } from '../types';

interface SettingsPanelProps {
  settings: TimerSettings;
  onUpdateSettings: (newSettings: Partial<TimerSettings>) => void;
}

const SettingsPanel: React.FC<SettingsPanelProps> = ({ 
  settings, 
  onUpdateSettings
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-text mb-4">
        Timer Settings
      </h3>
      
      <div className="space-y-4">
        {/* Duration settings */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-text mb-1">
              Work Duration
            </label>
            <div className="flex items-center space-x-2">
              <input
                type="number"
                min="1"
                max="60"
                value={settings.workDuration}
                onChange={(e) => onUpdateSettings({ workDuration: parseInt(e.target.value) || 25 })}
                className="w-16 px-3 py-2 border border-accent rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <span className="text-sm text-text/60">minutes</span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text mb-1">
              Short Break
            </label>
            <div className="flex items-center space-x-2">
              <input
                type="number"
                min="1"
                max="30"
                value={settings.shortBreakDuration}
                onChange={(e) => onUpdateSettings({ shortBreakDuration: parseInt(e.target.value) || 5 })}
                className="w-16 px-3 py-2 border border-accent rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <span className="text-sm text-text/60">minutes</span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-text mb-1">
              Long Break
            </label>
            <div className="flex items-center space-x-2">
              <input
                type="number"
                min="1"
                max="60"
                value={settings.longBreakDuration}
                onChange={(e) => onUpdateSettings({ longBreakDuration: parseInt(e.target.value) || 15 })}
                className="w-16 px-3 py-2 border border-accent rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <span className="text-sm text-text/60">minutes</span>
            </div>
          </div>
        </div>

        {/* Toggle settings */}
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="checkbox"
              checked={settings.autoStart}
              onChange={(e) => onUpdateSettings({ autoStart: e.target.checked })}
              className="w-5 h-5 text-primary bg-white border-accent rounded focus:ring-primary focus:ring-2"
            />
            <div>
              <span className="text-text font-medium">Auto-start next session</span>
              <p className="text-sm text-text/60">Automatically start the next session after completion</p>
            </div>
          </label>

          <label className="flex items-center space-x-3 cursor-pointer">
            <input
              type="checkbox"
              checked={settings.soundEnabled}
              onChange={(e) => onUpdateSettings({ soundEnabled: e.target.checked })}
              className="w-5 h-5 text-primary bg-white border-accent rounded focus:ring-primary focus:ring-2"
            />
            <div>
              <span className="text-text font-medium">Sound notifications</span>
              <p className="text-sm text-text/60">Play sound when sessions complete</p>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel; 